import { StyleObject } from 'styletron-react';

export const wrapper = () => {
    return {
        display: 'flex',
        boxSizing: 'border-box',
        transform: 'translate3d(var(--translate-x, 0), var(--translate-y, 0), 0) scaleX(var(--scale-x, 1)) scaleY(var(--scale-y, 1))',
        transformOrigin: '0 0',
        touchAction: 'manipulation',
    } as StyleObject;
}

export const itemStyle = (dragOverlay: boolean) => {
    return {
        position: 'relative',
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        padding: '18px 20px',
        backgroundColor: '#fff',
        boxShadow: '0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05), 0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15)',
        outline: 'none',
        border: '1px solid transparent',
        borderRadius: 'var(--epods--border-radius)',
        boxSizing: 'border-box',
        listStyle: 'none',
        transformOrigin: '50% 50%',
        '-webkit-tap-highlight-color': 'transparent',
        color: '#333',
        fontWeight: '100',
        fontSize: '1rem',
        whiteSpace: 'nowrap',
        transform: 'scale(var(--scale, 1))',
        transition: 'box-shadow 200ms cubic-bezier(0.18, 0.67, 0.6, 1.22)',
        cursor: dragOverlay ? 'grabbing' : 'grab',
        ':focus-visible': {
            boxShadow: '0 0px 4px 1px #4c9ffe, 0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05), 0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15)',
        },
        ':hover': {
            border: '1px solid var(--epods--color-border)',
            borderRadius: 'var(--epods--border-radius)',
        }
    }
}

export const itemDragging = (condition: boolean) => {
    return condition
        ? {
            opacity: '1',
            backgroundColor: 'var(--epods--color-bluegrey-100)',
            zIndex: 0,
            ':focus': {
                boxShadow: '0 0px 4px 1px var(--epods--color-bluegrey-100), 0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05), 0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15)'
            }
        }
        : {}
}

export const remove = () => {
    return {
        visibility: 'hidden',
    }
}
export const actions = () => {
    return {
        display: 'flex',
        alignSelf: 'flex-start',
        marginTop: '-12px',
        marginLeft: 'auto',
        marginBottom: '-15px',
        marginRight: '-10px',
    }
}
